import React, { useEffect } from "react";
import { Grid } from "@mui/material";
import { NavLink } from "react-router-dom";
import { Container, Link, Typography } from "@mui/material";
import PropTypes from "prop-types";
import dayjs from "dayjs";

import MainTitle from "components/MainTitle";
import { categoriesPage } from "utils/holidaysUtils";
import HolidayPresenter from "presenters/HolidayPresenter";
import { appRoutes } from "routes";
import MetaTags from "components/MetaTags";
import { useGtm } from "hooks";
import ResponsiveImage from "components/ResponsiveImage";

import useStyles from "./useStyles";

const Categories = ({ dateSelected }) => {
  const classes = useStyles();
  const categories = categoriesPage(dateSelected);
  const { trackVirtualPageView } = useGtm();

  useEffect(() => trackVirtualPageView({ name: "category-directory" }), []);

  const renderCategory = (category) => (
    <Link to={appRoutes.categoryPath(HolidayPresenter.slug(category))} component={NavLink}>
      <div className={classes.hover}>
        <ResponsiveImage
          src={HolidayPresenter.src(category)}
          alt={HolidayPresenter.alt(category)}
          className={classes.categoryImage}
          width={290}
          widthMobile={184.5}
        />
      </div>
    </Link>
  );

  return (
    <>
      <div className={classes.root}>
        <Container>
          <Typography variant="h1" className={classes.title}>
            All eCard Categories
          </Typography>
          <Grid container spacing={3}>
            {categories.map((category) => (
              <Grid item xs={6} sm={3} key={HolidayPresenter.name(category)}>
                {renderCategory(category)}
              </Grid>
            ))}
          </Grid>
        </Container>
      </div>
      <MainTitle title="Electronic Greeting Cards - Browse Animated eCard Categories!" />
      <MetaTags>
        <meta
          name="keywords"
          content="eCards, Christmas, Birthday, Valentines Day, Music Videos, Dances, Anniversary, Sports, Mothers Day, Easter, Sorry, Love, Halloween, Thanksgiving, Weddings"
        />
        <meta
          name="description"
          content="Personalized electronic cards from JibJab. Browse our animated cards collection by category & send funny electronic cards online for birthdays, holidays, and more!"
        />
        <meta property="og:title" content="eCard Category Directory - JibJab" />
        <meta
          property="og:description"
          content="Personalized eCards from JibJab for every occasion. Birthdays, holidays, congratulations for a new baby, recent graduate, or simply office humor."
        />
      </MetaTags>
    </>
  );
};

Categories.propTypes = {
  dateSelected: PropTypes.shape(Date),
};

Categories.defaultProps = {
  dateSelected: dayjs(),
};

export default Categories;
